module.exports = __webpack_public_path__ + "static/media/sign2.ff3d453d.png";